import { cn } from "@/lib/utils";

interface CircularProgressProps {
  value: number;
  total: number;
  showPercentage?: boolean;
  size?: "sm" | "md" | "lg";
}

export function CircularProgress({
  value,
  total,
  showPercentage = true,
  size = "sm",
}: CircularProgressProps) {
  const percentage = total > 0 ? (value / total) * 100 : 0;

  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-6 w-6",
    lg: "h-8 w-8",
  };

  return (
    <div className="flex items-center gap-1">
      <svg className={cn(sizeClasses[size], "-rotate-90 transform")}>
        <circle
          cx="8"
          cy="8"
          r="6"
          stroke="currentColor"
          strokeWidth="2"
          fill="transparent"
          className="text-gray-200"
        />
        <circle
          cx="8"
          cy="8"
          r="6"
          stroke="currentColor"
          strokeWidth="2"
          fill="transparent"
          strokeDasharray={`${(value / total) * 37.7} 37.7`}
          className={cn("transition-all duration-300", {
            "text-green-500": percentage <= 50,
            "text-yellow-500": percentage > 50 && percentage <= 75,
            "text-orange-500": percentage > 75 && percentage < 90,
            "text-red-500": percentage >= 90,
          })}
        />
      </svg>
      {showPercentage && (
        <span className="text-xs text-gray-500">
          ({Math.round(percentage)}%)
        </span>
      )}
    </div>
  );
}
